import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type monthlyReportsType = {
  dateFrom: string;
  dateTo: string;
  companyId?: string;
  errorCallback: Function;
  resultKey?: string;
};

export default ({
  dateFrom,
  dateTo,
  companyId = '',
  errorCallback,
  resultKey = 'monthlyReportsData',
}: monthlyReportsType) =>
  requestAsync({
    url: endpoints.getMonthlyReportsUrl(dateFrom, dateTo, companyId),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getMonthlyReportsUrl(dateFrom, dateTo, companyId),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
